import {errorActions} from "../ErrorHandler/errorHandler";
import api from "../../util/api";

export const actionTypes = {
    getNormalTracks: "getNormalTracks",
    setLoadingNormalTracks: "setLoadingNormalTracks",
    clearTracks: "clearTracks",
};

const initialTracksState = {
    normalTracks: [],
    isLoadingNormalTracks: true,
};

export const tracksReducer = (state = initialTracksState, action) => {
    switch (action.type) {
        case actionTypes.getNormalTracks: {
            const {normalTracks} = action.payload;
            return {...state, normalTracks};
        }

        //loaders:
        case actionTypes.setLoadingNormalTracks: {
            const {isLoadingNormalTracks} = action.payload;
            return {...state, isLoadingNormalTracks};
        }

        //clear:
        case actionTypes.clearTracks: {
            return initialTracksState;
        }

        default:
            return state;
    }
};

export const tracksActions = {
    getNormalTracks: () => async dispatch => {
        dispatch({
            type: actionTypes.setLoadingNormalTracks,
            payload: {isLoadingNormalTracks: true},
        });

        return api
            .get(`v2/api/tracks`, {
                method: "GET",
                headers: {},
            })
            .then(({data: {data = []}}) => {
                dispatch({
                    type: actionTypes.getNormalTracks,
                    payload: {normalTracks: data},
                });
                dispatch({
                    type: actionTypes.setLoadingNormalTracks,
                    payload: {isLoadingNormalTracks: false},
                });
            })
            .catch(err => {
                dispatch(errorActions.setErrorMessage(err.message));
                dispatch({
                    type: actionTypes.setLoadingNormalTracks,
                    payload: {isLoadingNormalTracks: false},
                });
            });
    },
    clearTracks: () => dispatch =>
        dispatch({
            type: actionTypes.clearTracks,
            payload: {},
        }),
};
